export default {
    title: "Centri di lavoro",
    icon: "mdi-factory",
    capability: "page.staff-centri-lavoro",
    groups: ["Amministrazione"],
    submenu: [
        {
            title: "Centri di lavoro",
            route: { name: "staff-centri-lavoro" },
            groups: ["Amministrazione"],
        },
    ],
};
